import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyCommunicationLeadTodoApiService } from './company-communication-lead-todo-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyCommunicationLeadTodoApiService extends GeneratedCompanyCommunicationLeadTodoApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
